module.exports = __webpack_public_path__ + "static/media/logo_black.59290113.svg";